import { memo } from 'react';
import { useParams } from 'react-router-dom';

import ActivityLog from '@/components/ActivityLog';
import PageHeader from '@/components/PageHeader';
import { useActivityLogByFormAnswerGroupId } from '@/hooks/useActivityLog/useActivityLog';
import usePerson from '@/hooks/usePerson';
import PersonContext from '@/pages/Person/PersonContext';
import Alert from '@/ui/components/Alert';
import Container from '@/ui/components/Container';
import LoadingSkeleton from '@/ui/components/LoadingSkeleton';

const ActivityLogByFormAnswerGroupId = () => {
  const { formAnswerGroupHealthieId } = useParams();

  if (!formAnswerGroupHealthieId) {
    throw new Error('formAnswerGroupHealthieId is required');
  }

  const {
    data: activityLog,
    error,
    isError,
    isPending
  } = useActivityLogByFormAnswerGroupId(formAnswerGroupHealthieId);

  const personId = activityLog?.person_id;
  const {
    handleUpdatePerson,
    usePersonQuery: { isLoading: isLoadingPerson, data: personResponse, refetch }
  } = usePerson({
    id: personId,
    enabled: !!personId
  });

  return (
    <Container type="page">
      <PageHeader headingText="Activity Log" />

      {isPending ? (
        <LoadingSkeleton />
      ) : isError ? (
        <>
          <Alert level="error">
            Failed to get activity log data. {error?.message && <span>{error.message}</span>}
          </Alert>
        </>
      ) : (
        <>
          {isLoadingPerson ? (
            <LoadingSkeleton />
          ) : personResponse?.data ? (
            <PersonContext.Provider
              value={{ person: personResponse.data, refetch, updatePerson: handleUpdatePerson }}>
              <ActivityLog activityLog={activityLog} />
            </PersonContext.Provider>
          ) : (
            <Alert level="error">Failed to get person data</Alert>
          )}
        </>
      )}
    </Container>
  );
};
export default memo(ActivityLogByFormAnswerGroupId);
